import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, GuidLinkActions, GuidLinkMutations } from './types';
import GuidLinkService from '@/shared/services/GuidLinkService';
const _actions = namespaceHelper.removeNamespace(namespace, GuidLinkActions);
const _mutations = namespaceHelper.removeNamespace(namespace, GuidLinkMutations);

export default {
  async [_actions.FETCH_ESTIMATE_LINK]({ commit }, params) {
    var result = await GuidLinkService.fetchEstimateLink(params);
    const value = result.data;
    commit(_mutations.SET_ESTIMATE_LINK, value);
  },
  async [_actions.FETCH_SERVICE_ORDER]({ commit }, params) {
    var result = await GuidLinkService.fetchServiceOrder(params);
    const value = Array.isArray(result.data) ? result.data[0] || {} : result.data || {};
    commit(_mutations.SET_ESTIMATE_LINK, value);
    return value;
  },
  async [_actions.FETCH_PARTS_ORDER]({ commit }, params) {
    var result = await GuidLinkService.fetchPartsOrder(params);
    const value = Array.isArray(result.data) ? result.data[0] || {} : result.data || {};
    commit(_mutations.SET_ESTIMATE_LINK, value);
    return value;
  },
  async [_actions.FETCH_ESTIMATE_LINK_LOOKUPS]({ commit }) {
    const result = await GuidLinkService.fetchEstimateLinkLookups();
    const value = result.data;
    commit(_mutations.SET_ESTIMATE_LINK_LOOKUPS, value);
  },
  async [_actions.FETCH_UNIT]({ commit }, unitId) {
    const unitResult = await GuidLinkService.fetchUnit(unitId);
    commit(_mutations.SET_UNIT, unitResult.data);
  },
  async [_actions.SUBMIT_ESTIMATE_LINK]({ commit }, params) {
    const result = await GuidLinkService.submitEstimateLink(params);
    const value = result.data;
    commit(_mutations.SET_ESTIMATE_LINK, value);
  },
  async [_actions.GET_PAYMENT_LINK]({ commit }, params) {
    const result = await GuidLinkService.getPaymentLink(params);
    const value = result.data;
    commit(_mutations.SET_PAYMENT_LINK, value);
    return result;
  }
};
